export type AppDataEnabledFeatures = AppDataClickablePhoneNumberFeature;

export enum AppDataEnabledFeatureNames {
    CLICKABLE_PHONE_NUMBERS = "clickable-phone-numbers",
}

export type AppDataClickablePhoneNumberFeature = AppDataFeature<
    AppDataEnabledFeatureNames.CLICKABLE_PHONE_NUMBERS,
    {
        type: "link";
        hrefPattern: string;
    }
>;

export type AppDataFeature<Name extends AppDataEnabledFeatureNames, OptionsType extends Record<string, unknown>> = {
    name: Name;
    enabled: boolean;
    options: OptionsType;
};
